/**
 * Define configurable API settings
 */
const ApiRoot = function() {
  this.domain = window.rezflow.api_url;
  this.api_key = null;

  this.$get = function () {
    var self = this;
    return {
      getDomain: function () {
        return self.domain;
      },
      getKey: function () {
        return self.api_key;
      }
    }
  };

  this.setDomain = function (domain) {
    this.domain = domain;
  };

  this.setKey = function (key) {
    this.api_key = key;
  };
};

const COOKIE = new WeakMap();
const RESOURCE = new WeakMap();

export class APIFactory {
  /* @ngInject */
  constructor(ipCookie, $rootScope, API, $resource) {
    const user = $resource.user
    COOKIE.set(this, ipCookie);
    RESOURCE.set(this, $resource);
    this.api = API;
    this.$rs = $rootScope;
    this.$resource = $resource;
    this.actions = {};
  }

  get company() {
    return this._company;
  }

  set company(id) {
    this._company = id;
  }

  get url() {
    return API.getDomain();
  }

  transform(actions, company) {
    angular.forEach(actions, (action, key) => {

      action.headers = Object.assign(action.headers || {}, {
        'Company': company || this.company
      });

      const auth = action.auth !== undefined ? action.auth : true;
      if(auth) {
        action.headers = Object.assign(action.headers, {
          'Authorization': this.authKey,
        });
      }
    });
    return actions;
  }

  req(company) {
    const user = this.$rs.user;
    if(company) {
      this.company = company
    } else {
      this.company = user ? user.activeCompany()._id : undefined;
    }
    return this.$resource(this.url, {}, this.transform(this.actions, this.company));
  }

  setAction(){}

  get authKey() {
    return `${this.api.api_key}^${this.Token}`;
  }

  get Token() {
    if(this.token) return this.token;
    return this.$rs._token;
  }

  set Token(token) {
    this.token = token;
    this.$rs._token = token;
    userCookie = COOKIE.get(this)('nvbUser');
    COOKIE.get(this).remove('nvbUser');
    if (this.$rs.user) {
      this.api.api_key = this.$rs.user.api_key;
      self.request = this.$rs.user.api_key + "^" + token;
    }
    if (userCookie) {
      this.api.api_key = userCookie.key;
      self.request = userCookie.key + "^" + token;
      angular.extend(userCookie, { token: token });
      COOKIE.get(this)('nvbUser', userCookie, { path: '/' });
    }
  }

  static init(ipCookie, $rootScope, API, $resource) {
    return new APIFactory(ipCookie, $rootScope, API, $resource)
  }

};

export const factory = (MODULE = 'RessieApp', name, Factory) => {
  Factory.init = function (ipCookie, $rootScope, API, $resource) {
    return new Factory(ipCookie, $rootScope, API, $resource);
  };
  Factory.init.$inject = ['ipCookie', '$rootScope', 'API', '$resource'];
  return angular.module(MODULE)
    .provider('API', ApiRoot)
    .factory(name, Factory.init);
}

export const importable = (NEW_MODULE) => {
  APIFactory.init.$inject = ['ipCookie', '$rootScope', 'API', '$resource'];
  return angular.module(NEW_MODULE, [])
    .provider('API', ApiRoot)
    .factory('Req', APIFactory.init);
}



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/api.js